import css from "./RequestHelpSelect.css";
import React, {useEffect, useState} from "react";
import {urlParams} from "../utils/request";
import useStarfishAPI from 'hooks/useStarfishAPI';
import PropTypes from "prop-types";
import Select from "common/StyledSelect";
import {getWord} from "../utils/tenant";

const RequestHelpCourseSelect = ({
   studentId,
   course,
   setCourse,
   isCourseRequired,
   interventionRule,
   isCourseAllowed
}) => {

  const [coursesResponse, callCoursesAPI] = useStarfishAPI();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    setCourse(null);
    setCourses([])
    if (isCourseAllowed && interventionRule && interventionRule.id) {
      callCoursesAPI('../student/getCoursesForStudent.html', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlParams({
          studentId: studentId,
          flagRuleId: interventionRule.id
        }, false)
      });
    }
  }, [interventionRule, studentId]);

  useEffect(() => {
    if (coursesResponse.data && coursesResponse.data.courses) {
      setCourses(coursesResponse.data.courses.map(courseItem => {
        return {
          id: courseItem.id,
          fullName: courseItem.fullName
        }
      }));
    }
  }, [coursesResponse]);

  const toSelectOption = (item) => {
    if (!item) return null;
    return {
      label: item.fullName,
      value: item.id
    }
  };

  const customCourseWord = getWord('course');
  return (
      <div className={css['input']}>
        <label htmlFor="course">{isCourseRequired && <span>*</span>} {customCourseWord}</label>
        <div className={css['input-select']}>
          <Select
              id="course"
              value={toSelectOption(course)}
              onChange={option => setCourse(courses.find(ruleItem => ruleItem.id === option.value))}
              options={courses.map(toSelectOption)}
              isLoading={coursesResponse.pending}
              maxMenuHeight={150}
              isDisabled={!isCourseAllowed}
              ariaLabel={customCourseWord}
          />
        </div>
      </div>
  );

};

RequestHelpCourseSelect.propTypes = {
  studentId: PropTypes.number.isRequired,
  course: PropTypes.object,
  setCourse: PropTypes.func.isRequired,
  isCourseRequired: PropTypes.bool.isRequired,
  isCourseAllowed: PropTypes.bool.isRequired,
  interventionRule: PropTypes.object
};

export default RequestHelpCourseSelect;
